export const addCategoryToDataLayer = (
    dataLayer: any[],
    categoryCrumb: { id: number; seoName: string }[]
): void => {
    if (Array.isArray(categoryCrumb) && categoryCrumb.length > 0) {
        dataLayer.push({
            c: {
                c: { id: categoryCrumb[categoryCrumb.length - 1].id },
                n: categoryCrumb[categoryCrumb.length - 1].seoName,
                l0: { id: 1 },
                ...(categoryCrumb[0] && {
                    l1: {
                        id: categoryCrumb[0].id,
                    },
                }),
                ...(categoryCrumb[1] && {
                    l2: {
                        id: categoryCrumb[1].id,
                    },
                }),
                ...(categoryCrumb[2] && {
                    l3: {
                        id: categoryCrumb[2].id,
                    },
                }),
                ...(categoryCrumb[3] && {
                    l4: {
                        id: categoryCrumb[3].id,
                    },
                }),
            },
        });
    }
};

export const addLocationToDataLayer = (dataLayer: any[], locationCrumb: { id: number }[]): void => {
    if (Array.isArray(locationCrumb) && locationCrumb.length > 0) {
        dataLayer.push({
            l: {
                c: { id: locationCrumb[locationCrumb.length - 1].id },
                l0: { id: 1 },
                ...(locationCrumb[0] && {
                    l1: {
                        id: locationCrumb[0].id,
                    },
                }),
                ...(locationCrumb[1] && {
                    l2: {
                        id: locationCrumb[1].id,
                    },
                }),
                ...(locationCrumb[2] && {
                    l3: {
                        id: locationCrumb[2].id,
                    },
                }),
                ...(locationCrumb[3] && {
                    l4: {
                        id: locationCrumb[3].id,
                    },
                }),
            },
        });
    }
};

export const addAdImgCountToDataLayer = (dataLayer: any[], imgCount: number): void => {
    dataLayer.push({
        a: {
            ...{ ic: `${imgCount}` },
        },
    });
};

export const updatePageTypeOnDataLayer = (dataLayer: any[], pageType: string): void => {
    dataLayer.push({
        p: {
            t: `${pageType}`,
        },
    });
};

export const getTheLatestDataLayerObject = (dataLayer: any[]): DataLayerBase => {
    return dataLayer.reduce((accumulator, currentObject) => {
        Object.keys(currentObject).forEach((key) => {
            // If the property is an object itself, merge it with the accumulator.
            if (currentObject[key] instanceof Object && accumulator[key]) {
                accumulator[key] = { ...accumulator[key], ...currentObject[key] };
            } else {
                // Otherwise, directly assign the property to the accumulator.
                accumulator[key] = currentObject[key];
            }
        });
        return accumulator;
    }, {});
};

export const getPageTypeFromDataLayer = (dataLayer): string => {
    return getTheLatestDataLayerObject(dataLayer)?.p?.t;
};

export type YesNo = 'Yes' | 'No' | 'yes' | 'no' | 'Y' | 'N' | undefined;

type Attributes = {
    seller_type?: string;
    vehicle_make?: string;
    vehicle_model?: string;
    vehicle_transimission?: string;
    vehicle_fuel_type?: string;
    cat_breed?: string;
    dog_breed?: string;
    deflead?: YesNo;
    vaccinated?: YesNo;
    microchipped?: YesNo;
    neutered_or_spayed?: YesNo;
};

export type DataLayerBase = {
    p: {
        t: string;
        pl: string;
    };
    c?: {
        l0: {
            id: number;
        };
        l1?: {
            id: number;
        };
        l2?: {
            id: number;
        };
        l3?: {
            id: number;
        };
        l4?: {
            id: number;
        };
    };
    l?: {
        l0: {
            id: number;
        };
        l1?: {
            id: number;
        };
        l2?: {
            id: number;
        };
        l3?: {
            id: number;
        };
        l4?: {
            id: number;
        };
    };
    a?: {
        id: number;
        dl: number;
        ic: number;
        cdt: number;
        lpdt: number;
        acs: string;
        u: {
            at: string;
        };
        attr?: Attributes;
        prc?: {
            amt: number | string;
            cur: string;
        };
    };
    s?: {
        attr?: Attributes;
        kw: string;
        pn: number; // page number
        sr_na: any[];
        sr_oa: any[];
        sr_ta: any[];
        t: 'Search' | 'Browse';
        tp: number;
        tr: number; // total results
    };
};
